<template>
  <component
    :is="component"
    @setEmail="setEmail"
    @setComponent="setComponent"
    :email="email"
    :initData="initData"
  />
</template>

<script>
import GetStarted from "./GetStarted";
import LogIn from "./LogIn";
import SignUp from "./signup";
import ForgottenPassword from "./ForgottenPassword";
import ConnectWallet from "@/components/wallet/ConnectWallet";

export default {
  components: {
    GetStarted,
    LogIn,
    SignUp,
    ForgottenPassword,
    ConnectWallet,
  },
  props: ["initComponent", "initData"],
  computed: {
    initEmail() {
      return this.initData?.email;
    },
  },
  data() {
    return {
      component: this.initComponent || "GetStarted",
      email: this.initEmail || null,
    };
  },
  methods: {
    setEmail(email) {
      this.email = email;
    },
    setComponent(component) {
      this.component = component;
      this.$store.dispatch("setAuthModal", {
        component: component,
      });
    },
  },
  watch: {
    initComponent: {
      immediate: true,
      handler(value) {
        this.component = value;
      },
    },
    initEmail: {
      immediate: true,
      handler(val) {
        this.email = val;
      },
    },
  },
};
</script>